import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import ReferenceTemplate from './ReferenceTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class ReferenceComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.POSTBACK)

    this.data.noContextMenu = true 
    this.data.canNotBeDeleted = true
    this.data.component = ReferenceTemplate 
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    // Sets nodes canonical name
    node.lingualName = lingualName.POSTBACK
    this.setConnection()
    
    // const referenceInput = new Rete.Input(
    //   CONST_SOCKET.REFERENCE_INPUT, 
    //   lang.postback_socket_input_trigger, 
    //   this.socket.referenceInput, 
    //   true
    // )

    // node.addInput(referenceInput)

    const referenceInputActionButton = new Rete.Input(
      CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON, 
      lang.postback_socket_input_action_button, 
      this.socket.referenceInputActionButton, 
      false
    )

    node.addInput(referenceInputActionButton)

    const referenceOutput = new Rete.Output(
      CONST_SOCKET.REFERENCE_OUTPUT, 
      lang.postback_socket_output_next, 
      this.socket.referenceOutput, 
      false
    )

    node.addOutput(referenceOutput)

    if (this.isSequenceAddonAvailable) {
      const referenceOutputSequence = new Rete.Output(
        CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE, 
        lang.postback_new_socket_output_sequence, 
        this.socket.referenceOutputSequence,
        false
      )

      node.addOutput(referenceOutputSequence)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.REFERENCE_OUTPUT] = node.data
  }

  setConnection() {
    // Reference may be connected to:
    this.socket.referenceOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.referenceOutput.combineWith(this.socket.openaiInput)
    this.socket.referenceOutput.combineWith(this.socket.carouselInput)
    this.socket.referenceOutput.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.referenceOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.referenceOutput.combineWith(this.socket.videoInput)
      this.socket.referenceOutput.combineWith(this.socket.audioInput)
      this.socket.referenceOutput.combineWith(this.socket.fileInput)
      // this.socket.referenceOutput.combineWith(this.socket.otnInput)
    }

    if(recurring_notification_display)
      this.socket.referenceOutput.combineWith(this.socket.rcnInput)

    this.socket.referenceOutput.combineWith(this.socket.ecommerceInput)
    this.socket.referenceOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.referenceOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.referenceOutput.combineWith(this.socket.httpApiInput)
    }
    
    if (this.isUserInputFlowAddonAvailable) {
      this.socket.referenceOutput.combineWith(this.socket.userInputFlowInput)
    }
    
    // Output: Sequence
    if (this.isSequenceAddonAvailable) {
      this.socket.referenceOutputSequence.combineWith(this.socket.sequenceInput)    
    }
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.referenceOutput.combineWith(this.socket.conditionInput)
    }

  }
}